import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Select,
    MenuItem,
    Button,
    Typography,
    InputAdornment,
    Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SEARCH_BY_LABELS = {
    mobile: "Mobile Number",
    // reference: "Reference ID",
    // aadhaar: "Aadhaar Card",
    // dl: "Driving License",
    // pan: "PAN Card",
    // passport: "Passport",
};

const SearchMembers = ({ onSearch, onCancel, resetSignal }) => {
    const [searchBy, setSearchBy] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const resetForm = () => {
        setSearchBy("");
        setSearchValue("");
        setHasSubmitted(false);
    };

    useEffect(() => {
        if (resetSignal) {
            resetForm();
        }
    }, [resetSignal]);

    const handleSearch = () => {
        setHasSubmitted(true); 
        if (!searchBy || !searchValue) return;
        onSearch({ searchBy, searchValue });
    };
    const handleCancel = () => {
        resetForm();
        onCancel();
    };

    return (
        <Box sx={{ padding:3,paddingBottom:1 , backgroundColor: "#fff", marginBottom: "20px", borderRadius: "8px" }}>

            {/* Search Section */}
            <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} sm={3}>
   <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Select
                        value={searchBy}
                        onChange={(e) => setSearchBy(e.target.value)}
                        displayEmpty
                        error={hasSubmitted && !searchBy}
                        sx={{
                            width: 240,
                            height: 44,
                            backgroundColor: "#fff",
                            borderRadius: "6px",
                            "& .MuiSelect-select": {
                                display: "flex",
                                alignItems: "center",
                                fontSize: "14px",
                            },
                        }}
                        renderValue={(selected) =>
                            selected ? SEARCH_BY_LABELS[selected] : "Search By"
                        }
                    >
                        {Object.keys(SEARCH_BY_LABELS).map((key) => (
                            <MenuItem key={key} value={key}>
                                {SEARCH_BY_LABELS[key]}
                            </MenuItem>
                        ))}
                    </Select>

                    <Typography
                        variant="caption"
                        color="error"
                        sx={{
                            mt: 0.5,
                            minHeight: "18px",
                            visibility: hasSubmitted && !searchBy ? "visible" : "hidden",
                        }}
                    >
                        Please select search type
                    </Typography>
                </Box>

                </Grid>


                <Grid item xs={12} sm={5}>
                    <TextField
                        size="small"
                        fullWidth
                        placeholder="Search Members"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        error={hasSubmitted && !searchValue} 
                        helperText={
                            hasSubmitted && !searchValue
                                ? "Please enter search value"
                                : ""
                        } 
                        sx={{
                            width: 320,
                            "& .MuiOutlinedInput-root": {
                                height: 44,
                                borderRadius: "6px",
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />

                </Grid>

                <Grid item xs={12} sm={4}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#d32f2f",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                backgroundColor: "#fff",
                                border: "1px solid #d32f2f",
                                height: 44,
                            }}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            sx={{
                                height: 44,
                                px: 4,
                                fontWeight: 600,
                                textTransform: "uppercase",
                            }}
                            onClick={handleSearch}
                        >
                            Search
                        </Button>

                    </Box>
                </Grid>
            </Grid>

        </Box>
    );
};

export default SearchMembers;
